'use client'

import type { User } from '@maestro/data-layer'

import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

import { useMaestroSession } from '@maestro/commerce-blocks/providers/maestro-session/maestro-session.context'
import { theme } from '@maestro/local/theme'

export const usePageViewData = () => {
  const pathname = usePathname()

  const { session } = useMaestroSession()
  const {
    site: { locale },
  } = theme()

  const pageViewData = useMemo(() => {
    const user = session?.user as User | undefined
    const isLoggedIn = !!user?.id
    const loginStatus = isLoggedIn ? 'logged_in' : 'logged_out'
    const clubMember = user?.isMember ? 'member' : 'not member'

    return {
      page_location:
        typeof window !== 'undefined'
          ? `${window.location.origin}${pathname}${window.location.search}`
          : undefined,
      page_path: pathname,
      get page_title() {
        return typeof document !== 'undefined' ? document.title : undefined
      },
      language: locale,
      login_status: loginStatus,
      club_member: clubMember,
      user_id: user?.id || undefined,
      user_data: {
        email_address: session?.user?.email || undefined,
        phone_number: session?.user?.phone || undefined,
        first_name: session?.user?.name || undefined,
        last_name: session?.user?.lastName || undefined,
        street: session?.user?.defaultAddress?.line1 || undefined,
        city: session?.user?.defaultAddress?.town || undefined,
        region: undefined,
        postal_code: session?.user?.defaultAddress?.postalCode || undefined,
        country: session?.user?.defaultAddress?.country?.name || undefined,
        total_order_count: session?.user?.orderCount || 0,
        total_lifetime_value: session?.user?.orderTotals || 0,
      },
    }
  }, [session?.user, pathname, locale])

  return pageViewData
}
